import { API_URL } from '@/config';
import { startAuthentication, startRegistration } from "@simplewebauthn/browser";

export interface Credential {
	id: string;
	transports: string[];
	type: string;
}
async function sendGraphQLQuery(query: string, variables: Record<string, any> = {}) {
	const response = await fetch(`${API_URL}`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ query, variables }),
	});

	const json = await response.json();
	if (json.errors) {
		throw new Error(json.errors.map((e: any) => e.message).join(", "));
	}
	return json.data;
}

// **STEP 1: Start WebAuthn Registration (Get Challenge from Server)**
export async function getRegistrationChallenge(userId: number) {
	const query = `
	query ($userId: Int!) {
		Authentication {
			getRegistrationChallenge(userId: $userId) {
				challenge {
					rp {
						name
						id
					}
					authenticatorSelection {
						userVerification
					}
					user {
						id
						name
						displayName
					}
					pubKeyCredParams {
						type
						alg
					}
					attestation
					extensions {
						exts
					}
					timeout
					challenge
					excludeCredentials
				}
			}
		}
	}
	`;
	return sendGraphQLQuery(query, { userId });
}

// **STEP 2: Complete WebAuthn Registration**
export async function registerWebAuthn(userId: number, response: any) {
	const mutation = `
	mutation ($userId: Int!, $response: String!) { AuthenticationMutations {
		registerWebAuthn(userId: $userId, response: $response) {
			status
		}
	}
	}
	`;
	return sendGraphQLQuery(mutation, { userId, response: JSON.stringify(response) });
}

// **STEP 3: Start WebAuthn Authentication (Get Challenge from Server)**
export async function getAuthenticationChallenge() {
	const query = `
	query  { Authentication {
		getAuthenticationChallenge {
			publicKey {
				timeout
				challenge
				userVerification
				rpId
				allowCredentials {
					id
					transports
					type
				}

			}
		}
	}
	}
	`;
	return sendGraphQLQuery(query);
}

// **STEP 4: Complete WebAuthn Authentication**
export async function verifyWebAuthn(userId: number, assertionResponse: any) {
	const mutation = `
	mutation ($userId: Int!, $assertionResponse: String!) { AuthenticationMutations {
		verifyWebAuthn(userId: $userId, assertionResponse: $assertionResponse) {
			id
			status
		}
	}
	}
	`;
	return sendGraphQLQuery(mutation, { userId, assertionResponse: JSON.stringify(assertionResponse) });
}
export async function logout() {
	const mutation = `mutation  { AuthenticationMutations { logout  } } `;
	return sendGraphQLQuery(mutation, {});
}
export async function getPassKeyStatus( userId: number) {
	const query = ` query ($userId: Int!) { Authentication { getPassKeyStatus(userId: $userId) } } `;
	return sendGraphQLQuery(query, {userId});
}



